<ul class="mainNav-list">
    
    <li class="mainNav-item" *ngIf="isRouteActive('appointments')" (click)="setPage('Calendar')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Calendar' ? 'is-active':''">
            Calendar
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('appointments')" (click)="setPage('Patients')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Patients' ? 'is-active':''">
           Patients
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('settings')" (click)="setPage('exams')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'exams' ? 'is-active':''">
           Exams Settings
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('settings')" (click)="setPage('Activity Hours')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Activity Hours' ? 'is-active':''">
            Activity Hours
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('settings')" (click)="setPage('Reports')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Reports' ? 'is-active':''">
             Reports
        </span>
    </li>
    <li class="mainNav-item" *ngIf="isRouteActive('settings')" (click)="setPage('Sms')" >
        <span class="mainNav-link" [ngClass]="currentPage == 'Sms' ? 'is-active':''">
             Sms Settings
        </span>
    </li>
    
  

    </ul>
